/** Currency units per Mtok ↔ micro-units. Input conversion only. */
export function currencyToMicro(value: string): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 1_000_000);
}

export function microCaption(value: string): string {
  return String(currencyToMicro(value));
}

/** A stored micro amount → the currency-unit string a rate field is prefilled with. */
export function microToInput(micro: number): string {
  const scaled = Math.round(micro);
  const sign = scaled < 0 ? '-' : '';
  const abs = Math.abs(scaled);
  const whole = Math.floor(abs / 1_000_000);
  const frac = String(abs % 1_000_000).padStart(6, '0');
  const trimmed = frac.replace(/0+$/, '');
  const keep = trimmed.length < 2 ? frac.slice(0, 2) : trimmed;
  return `${sign}${whole}.${keep}`;
}
